// extracted by mini-css-extract-plugin
export default {"assetsCardContents":"assets-card-module__assetsCardContents--Xm1Nc"};